import { ProgressCircleManySegments } from "@/components/ui/charts/progress-circle-many-segments";
import { getDimensionById } from "@/lib/dimensions";
import { cn } from "@/lib/utils";
import { DimensionResult } from "@/requests/reports/performance-detail-report.request";
import { DimensionId } from "@/types/questionnaries";
import { FC } from "react";

type DimensionDetailsTableProps = {
  className?: string;
  dimensionResult: DimensionResult;
};

const DimensionDetailsTable: FC<DimensionDetailsTableProps> = ({
  className,
  dimensionResult,
}) => {
  const uiConfig = getDimensionById(
    dimensionResult.dimension.dimension as DimensionId,
  );

  const topics = dimensionResult.topicsResult || [];

  return (
    <div className={cn(className)}>
      {uiConfig && (
        <div className="mb-4 flex items-center gap-2">
          <uiConfig.icon style={{ color: uiConfig.color }} />
          <p
            className="text-xl font-semibold"
            style={{ color: uiConfig.color }}
          >
            {uiConfig.label}
          </p>
        </div>
      )}

      {/* <p className="mb-6 text-sm text-[#8090A3]">
        Descripción del resultado aquí
      </p> */}

      <div className="flex flex-col items-center">
        <ProgressCircleManySegments
          className="my-4"
          radius={70}
          strokeWidth={20}
          segments={[
            {
              color: "#F1F4F9",
              value: 100 - dimensionResult.result.scorePercentage,
            },
            {
              color: uiConfig?.color || "#000",
              value: dimensionResult.result.scorePercentage,
            },
          ]}
        >
          <div className="text-center text-lg font-semibold text-black">
            {dimensionResult.result.scorePercentage}%
          </div>
        </ProgressCircleManySegments>

        {/* <p className="mt-4 text-xl font-bold">algo</p> */}
      </div>

      <div className="mt-4 overflow-hidden rounded-2xl border">
        <table className="w-full">
          <thead className="rounded-t-2xl">
            <tr
              className="text-center text-sm font-semibold text-white"
              style={{ backgroundColor: uiConfig?.color }}
            >
              <th className="p-4">Apertura</th>
              <th className="p-4 text-right">Porcentaje</th>
              <th className="p-4 text-right">Puntaje</th>
            </tr>
          </thead>
          <tbody>
            {topics.map((topic, index) => (
              <tr
                key={index}
                className="border-b text-sm font-light last-of-type:border-0 hover:bg-secondary"
              >
                <td className="px-4 py-3">{topic.topic.name}</td>
                <td className="px-4 py-3 text-right">
                  {topic.result.scorePercentage}%
                </td>
                <td className="px-4 py-3 text-right">{topic.result.score}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DimensionDetailsTable;
